import React from 'react';
import {getPageData} from '../../sources/CmsSource';
import {useGetPageData} from '../../actions/CmsActions';
import HomeContainer from './Home.container';

const cmsUrlPattern = '/home';

const HomeView = () => {
    const pageData = useGetPageData({cmsUrlPattern});
    return <HomeContainer pageData={pageData || {}} />;
};

HomeView.getInitialProps = async (match, {locale}) => {
    const rawPageData = await getPageData(cmsUrlPattern);

    //must match structure of StoreProvider
    return {
        cms: {
            [cmsUrlPattern]: rawPageData
        }
    };
};

export default HomeView;
